module.exports = __webpack_public_path__ + "static/automation-a6cacb50c29c57b9e55c2902bfb80134.png";